module.exports = __webpack_public_path__ + "images/_/programs/keepCool/images/level-5_start-a29b7169ad26a58a9755c49ddbee2070.png";


//////////////////
// WEBPACK FOOTER
// ./programs/keepCool/images/level-5_start.png
// module id = 444
// module chunks = 2